<template>
  <ExternalQueryList
      endpoint="/api/v2/orders"
      :headlines="headlines"
      :filters="filters"
      :can-update="() => true"
      @show="order => $router.push('/companies/'+order.attributes.company_id +'/orders/'+order.id)"
  >
    <template v-slot:default="{ row: order }">
      <td class="table__ellipsis">
        <router-link :to="'/companies/' + order.attributes.company_id + '/orders/' + order.id">
          HG{{ order.id }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.title }}
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.purchase_order }}
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.price_after_costs | price }}
      </td>

      <td class="table__ellipsis">
        {{ order.attributes.created_at | date }}
      </td>

      <td class="table__ellipsis">
        <router-link :to="'/companies/' + order.attributes.company_id">
          {{ order.attributes.company_name }}
        </router-link>
      </td>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import StatusLabel from '../../../StatusLabel'
import store from '@/store'
import Permissions from "../../../../mixins/Permissions";

export default {
  components: {ExternalQueryList, StatusLabel},

  mixins: [Permissions],

  props: {
    users: {
      required: true
    },
  },

  data() {
    return {
      shared: store
    }
  },

  computed: {
    headlines() {
      return [
        {width: 2, text: 'Number'},
        {width: 6, text: 'Title'},
        {width: 4, text: 'Purchase Order'},
        {width: 2, text: 'Price'},
        {width: 2, text: 'Date',},
        {width: 6, text: 'Company',},
      ]
    },

    filters() {
      return [
        [
          {
            width: 16,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'typeahead',
            name: 'user_id',
            placeholder: 'Choose User...',
            endpoint: '/api/v2/users',
            resultLabelProperty: row => row.attributes.full_name
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },
}
</script>
